export default __webpack_public_path__ + "static/media/tusuv.7b3859c4.png";